import { type IRole } from "@/interfaces/api/role/role.interface"
import { type RoleTypes } from "@/enums/role-types"
import { BaseModel } from "@/models/base.model"

export abstract class Role extends BaseModel implements IRole {
  public static className = "Role"
  public static verboseName = "Rol (algemeen)"

  id?: string
  knownBusinessEntityContact: string
  type: RoleTypes

  protected constructor(role: IRole) {
    super(role)

    this.id = role.id
    this.knownBusinessEntityContact = role.knownBusinessEntityContact
    this.type = role.type
  }

  public get verboseName(): string {
    return (this.constructor as typeof Role).verboseName
  }
}
